import { fromNgbDate, toDateFromNgbDate, toDateISOStringFromDateTime } from '@helpers/datetime-helper';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { DateTime } from 'luxon';
import { AgreementPeriodForm } from './shared-agreement.model';

export class AgreementFormHelper {
    public static getlastDateForNoticeToString(formValue: AgreementPeriodForm) {
        const date = this.getlastDateForNotice(formValue);
        if (date) {
            return toDateISOStringFromDateTime(date);
        }
        return '';
    }

    public static getlastDateForNotice(formValue: AgreementPeriodForm): DateTime | null {
        if (
            formValue?.validTo.value &&
            formValue?.noticePeriodTypeId.value != null &&
            formValue?.noticePeriod.value != null
        ) {
            const toDate = fromNgbDate(formValue.validTo.value);
            const noticePeriod = formValue.noticePeriod.value;
            const noticePeriodTypeId = formValue.noticePeriodTypeId.value;

            let date = toDate.minus({ months: noticePeriod });
            if (noticePeriodTypeId === 0) {
                date = toDate.minus({ days: noticePeriod });
            }
            return date;
        }
        return null;
    }

    public static getNoticeDate(formValue: AgreementPeriodForm): Date | null {
        let startDate: Date;
        if (formValue?.validTo.value) {
            const validToNgbDate: NgbDate = formValue.validTo.value;
            startDate = toDateFromNgbDate(validToNgbDate);
            if (formValue.noticePeriodTypeId.value === 1) {
                startDate.setMonth(startDate.getMonth() - (formValue.noticePeriod.value ?? 0));
            } else {
                startDate.setDate(startDate.getDate() - (formValue.noticePeriod.value ?? 0));
            }
        }
        return startDate;
    }

    public static getTerminationDate(formValue: AgreementPeriodForm): Date | null {
        const terminationDate = new Date();
        if (formValue?.validTo.value) {
            const validToNgbDate: NgbDate = formValue.validTo.value;
            return toDateFromNgbDate(validToNgbDate);
        }
        if (formValue.noticePeriodTypeId.value === 1) {
            terminationDate.setMonth(terminationDate.getMonth() + (formValue.noticePeriod.value ?? 0));
        } else {
            terminationDate.setDate(terminationDate.getDate() + (formValue.noticePeriod.value ?? 0));
        }
        return terminationDate;
    }

    public static getValidToAfterExtension(formValue: AgreementPeriodForm): Date | null {
        if (formValue?.validTo.value && formValue?.periodAfterExtension.value > 0) {
            const validToDate = fromNgbDate(formValue.validTo.value);
            const periodAfterExtension = formValue.periodAfterExtension.value;
            const periodTypeIdAfterExtension = formValue.periodTypeIdAfterExtension.value;

            if (periodTypeIdAfterExtension === 1) {
                // Months
                return validToDate.plus({ months: periodAfterExtension }).toJSDate();
            } else {
                // Days
                return validToDate.plus({ days: periodAfterExtension }).toJSDate();
            }
        }
        return null;
    }

    public static computeReminderDates(noticeDate: Date, reminderPeriod: number, numOfReminders: number): Date[] {
        if (!noticeDate) return [];

        const startDate = new Date(noticeDate);
        startDate.setMonth(noticeDate.getMonth() - (reminderPeriod ?? 0));
        const numReminders = numOfReminders ?? 1;

        if (numReminders < 1) return [];

        const dates: Date[] = [];
        const startTime = startDate.getTime();
        const endTime = noticeDate.getTime();
        const interval = (endTime - startTime) / (numReminders - 1 || 1);

        for (let i = 0; i < numReminders; i++) {
            dates.push(new Date(startTime + interval * i));
        }
        return dates;
    }
}
